import { TenantProvider } from "@/context/TenantContext";
import JambushrushtiApp from "@jambushrushti/App";
import "@jambushrushti/index.css";

function App() {
  return (
    <TenantProvider>
      <JambushrushtiApp basename="/" />
    </TenantProvider>
  );
}

export default App;
